export default "__VITE_ASSET__DYs5A01h__"